import React from 'react';
import './controls.css'

import { Button } from 'react-bootstrap';

function onClick(){
    alert('Great job!! you have completed the tutorial. The development of this plaform is still in progress but have a chat with other beginner developers over at the discord server.')
}

export default function (){
    return(
        <div className='controls'>
            <Button variant="outline-info" onClick={ onClick }>Run</Button>
        </div>
    )
}